// Init Tiny Sliders
//
// uses:
// - https://github.com/ganlanyuan/tiny-slider
//
(function (window) {
  var INIT_ATTR = 'data-tns-init';

  function createSliders(rootEl, selector, options, onInit) {
    var els = rootEl.querySelectorAll(selector + ':not([' + INIT_ATTR + '])');

    for (var i = 0; i < els.length; i++) {
      // `<noscript>` fallback images are parsed as live nodes, which stay in
      // "loading" state preventing the slider controls from being initialised.
      // Hence they must be removed.
      var fallbacks = els[i].querySelectorAll('noscript');
      for (var j = 0; j < fallbacks.length; j++) {
        fallbacks[j].remove();
      }

      options.container = els[i];
      var slider = tns(options);
      if (!slider) continue;

      els[i].setAttribute(INIT_ATTR, '');
      if (!onInit) continue;
      onInit(slider);
    }
  }

  window.initSliders = function (rootEl) {
    createSliders(rootEl, '.slider', {
      mouseDrag: true,
      gutter: 20,
      autoHeight: true,
      nav: false,
      // navPosition: 'bottom',
      controlsText: ['Previous', 'Next'],
    });

    createSliders(
      rootEl,
      '.carousel',
      {
        mouseDrag: true,
        autoHeight: false,
        nav: true,
        navPosition: 'bottom',
        controlsText: ['Previous', 'Next'],
      },
      function (carousel) {
        carousel.getInfo().controlsContainer.classList.add('carousel-controls');
      },
    );

    // Landing page v2 mobile-only sliders
    // eg: _partials/entry/bucketRowSimpleCards
    // eg: 'grid_v2_scroller' _lister profile
    createSliders(rootEl, '.carousel-sm-upto', {
      items: 1.2,
      gutter: 30,
      mouseDrag: true,
      center: true,
      navPosition: 'bottom',
      loop: false,
      controls: false,
      responsive: {
        900: {
          disable: true,
        },
      },
    });

    createSliders(
      rootEl,
      '.reel',
      {
        items: 1.1,
        gutter: 10,
        mouseDrag: true,
        autoHeight: false,
        loop: false,
        rewind: true,
        nav: true,
        navPosition: 'bottom',
        controlsText: ['Previous', 'Next'],
        responsive: {
          900: {
            items: 1.5,
            gutter: 30,
          },
        },
      },
      function (reel) {
        reel.getInfo().controlsContainer.classList.add('reel-controls');
      },
    );
  };

  initSliders(document);
})(this);
